export const SET_CURRENT_USER = "SET_CURRENT_USER"
export const SET_LANG = "SET_LANG"
export const SET_ADDRESS = "SET_ADDRESS"
export const SET_PAYMENT = "SET_PAYMENT"
export const UPDATE_CURRENT_USER = "UPDATE_CURRENT_USER"
export const SHOW_ORDER = "SHOW_ORDER" 
export const SHOW_BRANDS = "SHOW_BRANDS" 